<div class="dashboard-container">
    <div fxFlex="100" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="14px" fxLayout.lt-md="column" class="csp1">
        <div fxFlex="40" class="chartcontainer" *ngIf="Dashboardpage" >
            <mat-card class="bg-white">
             <mat-card-content>
                      <div fxLayoutAlign="center center" *ngIf="chartShow">
                        <ejs-accumulationchart #pie [tooltip]="tooltip" [title]="charttitle" class="csp2">
                          <e-accumulation-series-collection class="csp3">
                            <e-accumulation-series
                              [dataSource]="chdata" 
                              [palette]="palette" 
                              xName="SUB_FUND_NAME" 
                              yName="SUB_FUND_PERC" 
                              innerRadius="50%">
                            </e-accumulation-series>
                          </e-accumulation-series-collection>
                        </ejs-accumulationchart>
                      </div>
                  
                      <!-- label list -->
                      <div fxLayoutAlign="center start">
                        <ul>
                          <li *ngFor="let lab of labelArray" class="csp4">
                            <span class="csp6" [style.background]="lab.bulletcolor" [style.color]="lab.bulletcolor"></span>
                  
                            <span *ngIf="whiteoakChange1">
                              {{ lab.labname1 }} -
                            </span>
                            <span *ngIf="oldBridgeTable || arthaTable">
                              {{ lab.labname1 }} - Rs.
                            </span>
                            <span *ngIf="whiteoakChange" class="csp7">
                              {{ lab.labname1 }} - Gross Commitment
                            </span>
                            <span *ngIf="whiteoakChange" class="csp7">
                              {{ lab.labname2 }}.<span>{{ lab.labname3 }}</span> {{ lab.labname4 }}
                            </span>
                            <span *ngIf="whiteoakChange" class="csp7">
                              ({{ lab.labname5 }} %)
                            </span>
                            <span *ngIf="whiteoakChange1">
                              {{ lab.labname2 }}.<span>{{ lab.labname3 }}</span> {{ lab.labname4 }}
                            </span>
                            <span *ngIf="oldBridgeTable || arthaTable">
                              {{ lab.labname2 }}<span>{{ lab.labname3 }}</span> {{ lab.labname4 }}
                            </span>
                            <span *ngIf="whiteoakChange1">
                              ({{ lab.labname5 }} %)
                            </span>
                            <span *ngIf="oldBridgeTable || arthaTable">
                              ({{ lab.percentage }} %)
                            </span>
                          </li>
                        </ul>
                      </div>
                    </mat-card-content>
              </mat-card>
        </div>
        <div fxFlex="60" *ngIf="whiteoakChange">
            <div class="foliocontainer">
                <mat-card class="bg-white">
                    <mat-card-content>
                        <h4 fxLayoutAlign="center start" class="csp8">Investment Summary</h4>
                        <div class="table-scroll">
                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 folio-table gfg">
                                <ng-container matColumnDef="Fund Name">
                                    <th mat-header-cell *matHeaderCellDef>Fund Name</th>
                                        <th mat-header-cell *matHeaderCellDef>Folio No</th>
                                    <td mat-cell *matCellDef="let element let i = index" class="csp9">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                            {{element.name}}
                                        </span>
                                    </td>
                                </ng-container>

                                

                                <ng-container matColumnDef="FolioNo">
                                    <th mat-header-cell *matHeaderCellDef class="colprof padding_25">Folio No</th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10"
                                            [ngClass]="{'bold':element.isHeader==true}">
                                             {{element.folioNo}} 
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Class">
                                    <th mat-header-cell *matHeaderCellDef class="colprof padding_25">Class</th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                            {{element.class}} 
                                        </span>
                                    </td>
                                </ng-container>


                                <ng-container matColumnDef="Gross Commitment">
                                    <th mat-header-cell *matHeaderCellDef class="colprof">Gross  <br>Commitment</th>
                                    <td mat-cell *matCellDef="let element" class="colprof">
                                        <span class="csp10"[ngClass]="{'bold':element.isHeader==true}">
                                            <span>{{element.gross_amt1}}</span> <span>.</span>
                                            <span>{{element.gross_amt2}}</span>
                                            <span>&nbsp;{{element.gross_amt3}}</span>
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Net Commitment">
                                    <th mat-header-cell *matHeaderCellDef class="colprof">Capital <br>Contribution</th>
                                    <td mat-cell *matCellDef="let element" class="colprof">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                            <span>{{element.net_amt1}}</span> <span>.</span>
                                            <span>{{element.net_amt2}}</span>
                                            <span>&nbsp;{{element.net_amt3}}</span>

                                        </span>
                                    </td>
                                </ng-container>
                                    <ng-container matColumnDef="NAV">
                                        <th mat-header-cell *matHeaderCellDef class="colprof">&nbsp;NAV</th>
                                        <td mat-cell *matCellDef="let element" class="colprof">
                                            <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">&nbsp;
                                                <span>&nbsp;{{element.nav_amt}}</span>
                                            </span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="CB">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">&nbsp;Current Units</th>
                                        <td mat-cell *matCellDef="let element" class="padding_25">
                                            <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">&nbsp;
                                                <span>&nbsp;{{element.current_unit}}</span>
                                            </span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="CV">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">&nbsp;Current Valuation(in Rs)</th>
                                        <td mat-cell *matCellDef="let element" class="padding_25">
                                            <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">&nbsp;
                                                <span>&nbsp;{{element.nav_amt * element.current_unit | number : '.2-2'}}</span>
                                            </span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="NAV Date">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">&nbsp;NAV Date</th>
                                        <td mat-cell *matCellDef="let element" class="padding_25">
                                            <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">&nbsp;
                                                <span>&nbsp;{{element.nav_date}}</span>
                                            </span>
                                        </td>
                                    </ng-container>


                                <tr mat-header-row *matHeaderRowDef="whiteoakColumns;sticky:true"></tr>
                                <tr mat-row *matRowDef="let row; columns: whiteoakColumns"></tr>
                            </table>

                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <div fxFlex="100" *ngIf="Dashboardpage1">
            <div class="foliocontainer">
                <mat-card class="bg-white">
                    <mat-card-content>
                        <h4 fxLayoutAlign="center start" class="csp8">Portfolio Snapshot</h4>
                        <div class="table-scroll">
                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 folio-table">
                                <ng-container matColumnDef="Fund Name">
                                    <th mat-header-cell *matHeaderCellDef>Fund Name</th>
                                    <td mat-cell *matCellDef="let element let i = index" class="csp9">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                            {{element.name}}
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Gross Commitment">
                                    <th mat-header-cell *matHeaderCellDef class="colprof">Gross Commitment</th>
                                    <td mat-cell *matCellDef="let element" class="colprof">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                            <span>{{element.gross_amt1}}</span> <span>.</span>
                                            <span class="csp11">{{element.gross_amt2}}</span>
                                            <span>&nbsp;{{element.gross_amt3}}</span>
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Net Commitment">
                                    <th mat-header-cell *matHeaderCellDef class="colprof">Capital Contribution</th>
                                    <td mat-cell *matCellDef="let element" class="colprof">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                            <span>{{element.net_amt1}}</span> <span>.</span>
                                            <span class="csp11">{{element.net_amt2}}</span>
                                            <span>&nbsp;{{element.net_amt3}}</span>

                                        </span>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                            </table>

                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <div fxFlex="60" *ngIf="whiteoakChange1">
            <div class="foliocontainer">
                <mat-card class="bg-white">
                    <mat-card-content>
                        <h4 fxLayoutAlign="center start" class="csp8">Portfolio Snapshot</h4>
                        <div class="table-scroll">
                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 folio-table">
                                <ng-container matColumnDef="Fund Name">
                                    <th mat-header-cell *matHeaderCellDef>Fund Name</th>
                                    <td mat-cell *matCellDef="let element let i = index" class="csp9">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                            {{element.name}}
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Gross Commitment">
                                    <th mat-header-cell *matHeaderCellDef class="colprof">Gross Commitment</th>
                                    <td mat-cell *matCellDef="let element" class="colprof">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                            <span>{{element.gross_amt1}}</span> <span>.</span>
                                            <span class="csp11">{{element.gross_amt2}}</span>
                                            <span>&nbsp;{{element.gross_amt3}}</span>
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Net Commitment">
                                    <th mat-header-cell *matHeaderCellDef class="colprof">Capital Contribution</th>
                                    <td mat-cell *matCellDef="let element" class="colprof">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                             <span>{{element.net_amt1}}</span> <span>.</span>
                                            <span class="csp11">{{element.net_amt2}}</span>
                                            <span>&nbsp;{{element.net_amt3}}</span>

                                        </span>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                            </table>

                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <div fxFlex="60" *ngIf="oldBridgeTable">
            <div class="foliocontainer">
                <mat-card class="bg-white">
                    <mat-card-content> 
                        <h4 fxLayoutAlign="center start" class="csp8" >Portfolio Snapshot</h4>
                        <div class="table-scroll">
                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 folio-table">
                                    <ng-container matColumnDef="Fund Name">
                                        <th mat-header-cell *matHeaderCellDef class="padding_25">Fund Name</th>
                                    <td mat-cell *matCellDef="let element let i = index">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                            {{element.name}}
                                        </span>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="Share Class">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">Share Class
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="padding_25">
                                            <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                                <span>{{element.class}}</span>
                                            </span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Portfolio Value">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">Portfolio Value(in Rs.Crs.)*
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="padding_25">
                                            <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                                <span>&nbsp;{{decimalPoint(element.portfolio_value)}}</span>
                                            </span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="XIRR">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">XIRR%</th>
                                        <td mat-cell *matCellDef="let element" class="padding_25">
                                            <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                                <span>{{decimalXirr(element.xxirnumber)}}</span>
                                            </span>
                                        </td>
                                    </ng-container>
                                <ng-container matColumnDef="CA">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">Commitment
                                            Amount(in Rs.Crs.)#</th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10"
                                            [ngClass]="{'bold':element.isHeader==true}">
                                                <span>{{element.gross_amt1}}</span><span>.</span>
                                            <span>{{element.gross_amt2}}</span>
                                                <!-- <span class="csp11">{{element.gross_amt3}}</span> -->
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Con Amount">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">Contribution
                                            Amount(in Rs.Crs.)&#64;</th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                                <span>{{element.net_amt1}}</span><span>.</span>
                                            <span>{{element.net_amt2}}</span>
                                                <!-- <span class="csp11">{{element.net_amt3}}</span> -->

                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Units">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">No of Units
                                        </th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                                <span>{{decimalUnit(element.current_unit)}}</span>

                                        </span>
                                    </td>
                                </ng-container>
                                <!-- <ng-container matColumnDef="NAV">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">NAV</th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10"
                                            [ngClass]="{'bold':element.isHeader==true}">
                                                <span class="csp11">{{element.nav_amt}}</span>
                                        </span>
                                    </td>
                                </ng-container>

                                    <ng-container matColumnDef="NAVD">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">NAV DATE</th>
                                        <td mat-cell *matCellDef="let element" class="padding_25">
                                            <span class="csp10"
                                                [ngClass]="{'bold':element.isHeader==true}">
                                                <span class="csp11">{{element.nav_date}}</span>
                                            </span>
                                        </td>
                                    </ng-container> -->
                                <ng-container matColumnDef="CV">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">Current
                                            Value(Rs.)(AS on XX-YY-ZZZZ)</th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                                <span>{{element.current_unit}}</span>
                                        </span>
                                    </td>
                                </ng-container>


                                <tr mat-header-row *matHeaderRowDef="oldBridgeColumn;sticky:true"></tr>
                                <tr mat-row *matRowDef="let row; columns: oldBridgeColumn"></tr>
                            </table>

                            <div class="csp12">
                                <span>
                                    * Portfolio Value as on  {{this.dataSource ? this.dataSource[0].nav_date :
                                    ''}}
                                </span>
                            </div>
                            <div class="csp12">
                                <span>
                                    # Total Commitment Amount 
                                </span>
                            </div>
                            <div class="csp12">
                                <span>
                                    &#64; Total Contributed Amount
                                </span>
                            </div>
                        </div>
                    </mat-card-content>
                 </mat-card>
            </div>
        </div>
        <div fxFlex="60" *ngIf="arthaTable">
            <div class="foliocontainer">
                <mat-card class="bg-white">
                    <mat-card-content> 
                        <h4 fxLayoutAlign="center start" class="csp8" >Portfolio Snapshot</h4>
                        <div class="table-scroll">
                            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 folio-table">
                                    <ng-container matColumnDef="Fund Name">
                                        <th mat-header-cell *matHeaderCellDef class="padding_25">Fund Name</th>
                                    <td mat-cell *matCellDef="let element let i = index">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                            {{element.name}}
                                        </span>
                                    </td>
                                </ng-container>

                                    <ng-container matColumnDef="Share Class">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">Share Class
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="padding_25">
                                            <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                                <span>{{element.class}}</span>
                                            </span>
                                        </td>
                                    </ng-container>
                                <ng-container matColumnDef="CA">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">Commitment
                                            Amount(in Rs.Crs.)#</th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                                <span>{{element.gross_amt1}}</span><span>.</span>
                                            <span>{{element.gross_amt2}}</span>
                                                <!-- <span class="csp11">{{element.gross_amt3}}</span> -->
                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Con Amount">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">Contribution
                                            Amount(in Rs.Crs.)&#64;</th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                                <span>{{element.net_amt1}}</span><span>.</span>
                                            <span>{{element.net_amt2}}</span>
                                                <!-- <span class="csp11">{{element.net_amt3}}</span> -->

                                        </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Units">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">No of Units
                                        </th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10" [ngClass]="{'bold':element.isHeader==true}">
                                                <span>{{decimalUnit(element.current_unit)}}</span>
                                        </span>
                                    </td>
                                </ng-container>
                                <!-- <ng-container matColumnDef="NAV">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">NAV</th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10"
                                            [ngClass]="{'bold':element.isHeader==true}">
                                                <span class="csp11">{{element.nav_amt}}</span>
                                        </span>
                                    </td>
                                </ng-container>

                                    <ng-container matColumnDef="NAVD">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">NAV DATE</th>
                                        <td mat-cell *matCellDef="let element" class="padding_25">
                                            <span class="csp10"
                                                [ngClass]="{'bold':element.isHeader==true}">
                                                <span class="csp11">{{element.nav_date}}</span>
                                            </span>
                                        </td>
                                    </ng-container> -->
                                <ng-container matColumnDef="CV">
                                        <th mat-header-cell *matHeaderCellDef class="colprof padding_25">Current
                                            Value(Rs.)(AS on XX-YY-ZZZZ)</th>
                                    <td mat-cell *matCellDef="let element" class="padding_25">
                                        <span class="csp10"
                                            [ngClass]="{'bold':element.isHeader==true}">
                                                <!-- <span>{{element.net_amt1}}</span> <span>.</span> -->
                                                <span>{{element.current_unit}}</span>
                                                <!-- <span>&nbsp;{{element.net_amt3}}</span> -->
                                        </span>
                                    </td>
                                </ng-container>


                                <tr mat-header-row *matHeaderRowDef="arthaColumn;sticky:true"></tr>
                                <tr mat-row *matRowDef="let row; columns: arthaColumn"></tr>
                            </table>

                            <div class="csp12">
                                <span>
                                    * Portfolio Value as on  {{this.dataSource ? this.dataSource[0].nav_date :
                                    ''}}
                                </span>
                            </div>
                            <div class="csp12">
                                <span>
                                    # Total Commitment Amount 
                                </span>
                            </div>
                            <div class="csp12">
                                <span>
                                    &#64; Total Contributed Amount
                                </span>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>

    </div>
</div>